import { BoxModel } from "./box-model";

export class BoxGroup {
    public name!: string;
    public boxList: BoxModel[] = [];
}